import Result from '../components/results/Result';
// import * as equaloneV3dSdk from '../../../lib/equalone-sdk';
/**
 * EQualOneUIService is responsible for the global state of the application.
 * Here is the description of each state with corresponding impact
 * LOADING:
 *   initial state of the application, when it loads its configuration from EQualOne server through the JS lib
 *   no action shall be possible on any component
 *   a loading card is displayed
 *
 * ERROR:
 *   initialization failed. A reload shall be possible.
 *
 * READY:
 *   if initialization succeeded, app is initialized and ready to take action.
 *   all components shall accept actions
 *
 * COUPON_LOADING:
 *   a coupon has been requested. No action shall be possible until coupon ended or timeout
 *   if coupon succeeded, then back to READY state with new config
 *   if coupon failed, then back to READY with previous config
 *
 * TEST_RUNNING:
 *   a test is under process. No action shall be possible from other component.
 *   Only stop the current test is available as action
 *
 */

export const STATE = {
    LOADING: 'LOADING',
    READY: 'READY',
    ERROR: 'ERROR',
    COUPON_LOADING: 'COUPON_LOADING',
    TEST_RUNNING: 'TEST_RUNNING'
}

let equalone = EQ1_SDK;

export default class EQualOneUIService {
    constructor($rootScope, $timeout) {
        this.testResults = [];

        this.$rootScope = $rootScope;
        this.$timeout = $timeout;

        let config = $rootScope.config;
        this.state = STATE.LOADING;
        //this.state = STATE.READY;

        // expose computed enabled booleans for components
        // note: these booleans are wrapped in an object, because primitives CAN'T be passed by reference
        // therefore changes as reflected correctly in remote component as expected.
        // Usage in component, for example Coupon:
        // in constructor:
        //    this.enabled = $equalOneUIService.enabled
        // in template:
        //    {{enabled.coupon}}
        this.enabled = {
            loading: true,
            coupon: false,
            customfields: false,
            speedometer: false,
            location: false
        };
        this.computeEnabled();

        //on start, init SDK and Load config
        equalone.init(config.equalone.server, config.equalone.folder, (res) => {
            this.$timeout(() => {
                let scripts = this.getScripts();
                if (scripts && scripts.length>0) {
                    this.ready();
                    this.couponLoading(null, null);
                }
                else
                {
                    this.error();
                }
            }, 0)
        });

        this.sdkVersion = equalone.getVersion();
    }

    computeEnabled() {
        this.enabled.loading = this.isLoadingEnabled();
        this.enabled.coupon = this.isCouponEnabled();
        this.enabled.customfields = this.isCustomFieldsEnabled();
        this.enabled.speedometer = this.isSpeedOMeterEnabled();
    }


    isLoadingEnabled() {
        switch(this.state) {
            case STATE.LOADING:
                return true;
            default:
                return false;
        }
    }

    isCouponEnabled() {
        switch(this.state) {
            case STATE.READY:
            case STATE.ERROR:
                return true;
            case STATE.COUPON_LOADING:
            default:
                return false;
        }
    }

    isCustomFieldsEnabled() {
        switch(this.state) {
            case STATE.READY:
            case STATE.TEST_RUNNING:
            case STATE.ERROR:
                return true;
            case STATE.COUPON_LOADING:
            default:
                return false;
        }
    }

    isSpeedOMeterEnabled() {
        switch(this.state) {
            case STATE.READY:
            case STATE.TEST_RUNNING:
                return true;
            default:
                return false;
        }
    }

    loading() {
        this.state = STATE.LOADING;
        this.computeEnabled();
    }

    error() {
        this.state = STATE.ERROR;
        this.computeEnabled();
    }

    couponLoading(coupon, callback) {
        this.state = STATE.COUPON_LOADING;
        this.computeEnabled();

        equalone.updateConfig((res, error) => {
            //EQual One callbacks are performed outside Angular, need to wrap into $timeout to force digest cycle
            this.$timeout(() => {
                this.ready();
                callback(res);
            }, 0);
        }, coupon);
    }

    ready() {
        this.state = STATE.READY;
        this.computeEnabled();
    }

    testRunning() {
        this.state = STATE.TEST_RUNNING;
        this.computeEnabled();
    }

    getScripts() {
        try {
            return equalone.onClickManager.getScripts();
        }
        catch(e) {
            return [];
        }

    }

    setCurrentScript(script) {
        this.currentScript = script;
    }

    startScript(key, callback) {
        equalone.onClickManager.startScript(key, (step, index, data) => {
            if (step === 'SCRIPT_STARTED') {
                this.testResults = [];
            }
            callback(step, index, data);
        });
    }

    stopScript(key) {
        equalone.onClickManager.stopScript(key);
    }

    getResults() {
        return this.testResults;
    }

    /**
     * Adds a new Result to the stack
     * @returns {Result} The result created
     */
    startNewResult() {
        var result = new Result();
        this.getResults().push(result);
        return result;
    }

    sendCustomField(key, value) {
        equalone.addCustomField(key, value);
    }
}

EQualOneUIService.$inject = ['$rootScope', '$timeout'];


// WEBPACK FOOTER //
// ./src/equalone-ui/services/EQualOneUIService.js